<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <BaseInput name="address" :errors="errors" :label="$t('FormInputField.label.addressLine1')">

    <SkeleLoader v-show="isLoading" lines="1" contentIsFullWidth />

    <input
      v-show="!isLoading"
      type="text"
      id="address"
      ref="address"
      :class="{ hasErrors: errors }"
      :placeholder="$t('FormInputField.placeholder.addressLine1')"
      @keyup="(e)=> handleErrorClear(e.target.value)"
    >
    <a @click="cancel" @keydown.enter="cancel" tabindex="0">
      {{$t('FormInputField.guide.addressLine1')}}
    </a>
  </BaseInput>
</template>

<script setup>
import {
  onMounted,
  ref,
} from 'vue';

import useThirdPartyScripts from '@/composables/api/useThirdPartyScripts';
import BaseInput from '@/components/ui/inputs/BaseInput.vue';
import SkeleLoader from '@/components/ui/loaders/SkeleLoader.vue';

defineProps({
 errors: {
  type: String,
  default: '',
  },
});

const emit = defineEmits([
  'update:autocomplete',
  'update:cancel',
  'update:clearErrors',
]);

const { useGoogleMapsScript } = useThirdPartyScripts();
const address = ref(null);
const isLoading = ref(true);
let autocomplete = null;

const setSessionToken = () => {
  const sessionToken = new window.google.maps.places.AutocompleteSessionToken();
  autocomplete.setOptions({ sessionToken });
};

const handleAutoComplete = () => {
  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    const mappedPlace = place.address_components.reduce((obj, item) => {
      obj[item.types[0]] = item;
      return obj;
    }, {});
    emit('update:autocomplete', mappedPlace);
  });
  isLoading.value = false;
};

const handleErrorClear = (value) => {
  if (value) {
    return;
  }

  return emit('update:clearErrors');
};

const cancel = () => {
  emit('update:cancel');
};

const onScriptLoad = () => {
  if (!window.google || !window.google?.maps?.places?.Autocomplete) {
    cancel();
    return;
  }
  autocomplete = new window.google.maps.places.Autocomplete(address.value, {
    fields: ['address_components'],
  });
  setSessionToken();
  handleAutoComplete();
};

onMounted(() => {
  useGoogleMapsScript(onScriptLoad);
});

</script>

<style lang="scss">
.base-input {
  width: 100% !important;
  a {
    display: block;
    text-align: center;
    font-size: 1.2rem;
    padding-top: 0.4rem;
    cursor: pointer;
    text-decoration: underline;
  }
 .error.address {
    bottom: 16px;
    position: relative;
  }
}
</style>
